// extracted by mini-css-extract-plugin
export default {"historycontainer":"historicalRate_historycontainer__pac7D","btn2":"historicalRate_btn2__X+44D","descrip":"historicalRate_descrip__WDfIn"};